// extracted by mini-css-extract-plugin
export default {"grey300":"#e0e0e0","grid":"Color_grid__P-Qha","palette":"Color_palette__MLLSp"};